import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TransformationSection } from '../components/TransformationSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ui/ScrollProgress';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-cream font-sans text-charcoal selection:bg-rose selection:text-charcoal-light overflow-x-hidden" data-id="element-291">
      <ScrollProgress data-id="element-292" />

      <HeroSection data-id="element-293" />
      <ProblemSection data-id="element-294" />
      <MethodSection data-id="element-295" />
      <OfferSection data-id="element-296" />
      <AudienceSection data-id="element-297" />
      <HowItWorksSection data-id="element-298" />
      <TransformationSection data-id="element-299" />
      <PricingSection data-id="element-300" />
      <GuaranteeSection data-id="element-301" />
      <Footer data-id="element-302" />
    </main>;
}